class ProductFormOld extends Cart {
  constructor(subscriptionOptions) {
    super(product)
    console.log(product)

    if (typeof product.selling_plan_groups[0] !== "undefined") {
      var selling_plans = product.selling_plan_groups[0].selling_plans
      var selling_plans2 = product.selling_plan_groups
    } else {
      jQuery.getJSON(window.Shopify.routes.root + "products/" + product.handle + ".js", function (new_product) {
        var selling_plans = new_product.selling_plan_groups[0].selling_plans
        var selling_plans2 = new_product.selling_plan_groups[0]
      })
    }

    this.state = {
      numberOfCatsSelected: 1,
      productWeight: 20,
      remainder: 20,
      rechargeInterval: 0,
      purchaseType: "one-time-purchase",
      selectedVariantId: selected_variant.id,
      allVariants: product.variants,
      selectedBeingEditingVariantLine: null,
      sellingPlans: selling_plans,
      sellingPlans2: selling_plans2,
      count: 1,
    }

    this.oneTimePurchaseFormBlock = document.querySelector(".template-old #one-time-purchase-form-block")
    this.subscribeAndSaveFormBlock = document.querySelector(".template-old #subscribe-and-save-form-block")

    this.numberOfCatsCheckboxes = document.querySelectorAll(".template-old input[name='number-of-cats']")
    this.numberOfCatsManualCounters = document.querySelectorAll(".template-old button[name='number-of-cats-manual-counter']")
    this.numberOfCatsManualCounterValue = document.querySelector(".template-old #number-of-cats-manual-value")
    this.numberOfCatsManualCounterWrapper = document.querySelector(".template-old #number-of-cats-manual-counter-wrapper")

    this.oneTimePurchaseProductPrice = document.querySelector(".template-old #one-time-purchase-product-price")
    this.oneTimePurchaseProductWeightValue = document.querySelector(".template-old #one-time-purchase-product-weight-value")
    this.oneTimePurchaseProductWeightCounters = document.querySelectorAll(".template-old button[name='product-weight-counter']")
    this.freeSheepingBlock = document.querySelector(".template-old #free-sheeping-block")
    this.subscriptionOptions = subscriptionOptions

    this.overlay = document.getElementById("overlay")
    this.closeButton = document.querySelector(".pdp-modal__close")
    this.modal = document.querySelector(".pdp-modal")

    this.sub4Element = document.querySelector("#bag-add-to-cart-sub4")
    this.subElement = document.querySelector("#bag-add-to-cart-sub")
  }
  async fetchCart() {
    const response = await fetch("/cart.js")
    if (!response.ok) {
      throw new Error("Error fetching cart")
    }
    const cart = await response.json()
    return cart
  }
  checkOnlyFourMonthSubscription(cart) {
    if (cart.items.length > 0) {
      return cart.items.every((item) => item.product_type === "Cat Litter" && item.properties && item.properties._interval === 4)
    } else {
      return false
    }
  }
  updateDisplay(onlyFourMonthSubscription) {
    if (this.sub4Element && this.subElement) {
      if (onlyFourMonthSubscription) {
        this.sub4Element.style.display = "flex"
        this.subElement.style.display = "none"
      } else {
        this.sub4Element.style.display = "none"
        this.subElement.style.display = "flex"
      }
    }
  }
  async manageCart() {
    try {
      const cart = await this.fetchCart()
      const onlyFourMonthSubscription = this.checkOnlyFourMonthSubscription(cart)
      this.updateDisplay(onlyFourMonthSubscription)
    } catch (error) {
      console.error("ERROR:", error)
    }
  }
  init() {
    document.getElementById("one-time-purchase-product-price").textContent = `$34.13`;
    const savedSubProduct = JSON.parse(localStorage.getItem("subProduct"))
    let bagAddToCart = null
    let bagAddToCartSub = null
    if (document.querySelector("#bag-add-to-cart")) {
      bagAddToCart = document.querySelector("#bag-add-to-cart")
      bagAddToCart.addEventListener("click", () => {
        this.addBag()
      })
    }
    if (document.querySelector("#bag-add-to-cart-sub")) {
      bagAddToCartSub = document.querySelector("#bag-add-to-cart-sub")
      bagAddToCartSub.addEventListener("click", () => {
        this.addSubscriptionBag()
      })
    }
    if (document.querySelector("#bag-add-to-cart-sub4")) {
      document.querySelector("#bag-add-to-cart-sub4").addEventListener("click", () => {
        this.addSubscriptionBag4()
      })
    }
    this.manageCart()
    if (savedSubProduct) {
      const { weight, interval, line } = savedSubProduct
      this.showSelectedSubscription(weight, interval, line)
      localStorage.removeItem("subProduct")
    }

    // Adding listeners to toggle between subscribe and onetime purchase options
    const purchaseTypeCheckboxes = document.querySelectorAll(".template-old input[name='purchase-type']")
    purchaseTypeCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("click", ({ target }) => {
        if (target.id == "subscribe-and-save") {
          this.state.purchaseType = target.id
          this.oneTimePurchaseFormBlock.setAttribute("style", "display: none")
          this.subscribeAndSaveFormBlock.removeAttribute("style")
          if (document.querySelectorAll(".hide-block-when-one-time-purchase").length > 0) {
            document.querySelector(".hide-block-when-one-time-purchase").style.display = "block"
          }

          this.renderSubAndSaveOptions()
        }

        if (target.id == "one-time-purchase") {
          this.state.selectedBeingEditingVariantLine = null
          this.state.purchaseType = target.id
          this.subscribeAndSaveFormBlock.setAttribute("style", "display: none")
          if (document.querySelectorAll(".hide-block-when-one-time-purchase").length > 0) {
            document.querySelector(".hide-block-when-one-time-purchase").style.display = "none"
          }
          this.oneTimePurchaseFormBlock.removeAttribute("style")
          this.calculateWeightAndPrice()
        }

        this.showSavingsValue(`cat_${this.state.numberOfCatsSelected}`, this.state.productWeight)
        this.showSavingsValueInfo(`cat_${this.state.numberOfCatsSelected}`, this.state.productWeight)

        let selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == this.state.productWeight + "lbs")
        this.state.selectedVariantId = this.state.allVariants[selectedVariantIndex].id
      })
    })

    // adding listeners to change number of cats by selection
    this.numberOfCatsCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("click", ({ target }) => {
        const { value } = target.dataset
        this.state.numberOfCatsSelected = Number(value)
        this.numberOfCatsManualCounterWrapper.classList.remove("active")
        this.calculateWeightAndPrice()

        if (this.state.purchaseType === "subscribe-and-save") {
          this.renderSubAndSaveOptions()
        }
      })
    })

    // adding listeners to change number of cats by counter
    this.numberOfCatsManualCounters.forEach((counter) => {
      counter.addEventListener("click", ({ target }) => {
        this.numberOfCatsManualCounterWrapper.classList.add("active")
        this.numberOfCatsCheckboxes.forEach((checkbox) => (checkbox.checked = false))

        const numberOfCatsManualDecrementor = this.numberOfCatsManualCounters[0]
        const numberOfCatsManualIncrementor = this.numberOfCatsManualCounters[1]
        const { action } = target.dataset

        if (action === "increment") {
          if (this.state.numberOfCatsSelected < 4) {
            this.state.numberOfCatsSelected = parseInt(this.numberOfCatsManualCounterValue.textContent)
          }

          this.state.numberOfCatsSelected += 1
          if (this.state.numberOfCatsSelected == 9) {
            this.state.numberOfCatsSelected = 8
          }
          this.numberOfCatsManualCounterValue.textContent = this.state.numberOfCatsSelected
          this.calculateWeightAndPrice()

          if (this.state.numberOfCatsSelected > 4) {
            numberOfCatsManualDecrementor.removeAttribute("disabled")
          }

          if (this.state.numberOfCatsSelected + 1 === 9) {
            numberOfCatsManualIncrementor.setAttribute("disabled", true)
            this.state.numberOfCatsSelected = 8
            // const overlay = document.getElementById("overlay")
            // overlay.style.display = "block"
            // overlay.querySelector(".pdp-modal-form__value").focus()
          }
        }

        if (action === "decrement") {
          if (this.state.numberOfCatsSelected < 4) {
            this.state.numberOfCatsSelected = parseInt(this.numberOfCatsManualCounterValue.textContent)
          }

          this.state.numberOfCatsSelected -= 1
          this.numberOfCatsManualCounterValue.textContent = this.state.numberOfCatsSelected
          this.calculateWeightAndPrice()

          if (this.state.numberOfCatsSelected === 4) {
            numberOfCatsManualDecrementor.setAttribute("disabled", true)
          }
          if (this.state.numberOfCatsSelected < 9) {
            numberOfCatsManualIncrementor.removeAttribute("disabled")
          }
        }

        if (this.state.purchaseType === "subscribe-and-save") {
          this.renderSubAndSaveOptions()
        }
      })
    })

    // adding listener to change the state and target class when counter itself is clicked
    this.numberOfCatsManualCounterValue.addEventListener("click", () => {
      this.numberOfCatsManualCounterWrapper.classList.add("active")
      this.numberOfCatsCheckboxes.forEach((checkbox) => (checkbox.checked = false))

      this.state.numberOfCatsSelected = parseInt(this.numberOfCatsManualCounterValue.textContent)
      this.calculateWeightAndPrice()

      if (this.state.purchaseType === "subscribe-and-save") {
        this.renderSubAndSaveOptions()
      }
    })

    // adding listeners to change the product weight by counter
    this.oneTimePurchaseProductWeightCounters.forEach((counter) => {
      counter.addEventListener("click", ({ target }) => {
        const weightDecrementor = this.oneTimePurchaseProductWeightCounters[0]
        const weightIncrementor = this.oneTimePurchaseProductWeightCounters[1]
        const { action } = target.dataset

        if (action === "increment") {
          this.state.productWeight += 20
          this.oneTimePurchaseProductWeightValue.textContent = this.state.productWeight + "lbs"
          let cat = this.state.productWeight / 10
          this.showSavingsValueInfoOne(`cat_${cat}`, this.state.productWeight)
          if (this.state.productWeight > 20) {
            weightDecrementor.removeAttribute("disabled")
          }

          if (this.state.productWeight + 20 > 80) {
            weightIncrementor.setAttribute("disabled", true)
          }
        }

        if (action === "decrement") {
          if (this.state.productWeight - 20 === 0) return

          this.state.productWeight -= 20

          this.oneTimePurchaseProductWeightValue.textContent = this.state.productWeight + "lbs"

          let cat = this.state.productWeight / 10
          this.showSavingsValueInfoOne(`cat_${cat}`, this.state.productWeight)
          if (this.state.productWeight === 20) {
            weightDecrementor.setAttribute("disabled", true)
          }

          if (this.state.productWeight < 80) {
            weightIncrementor.removeAttribute("disabled")
          }
        }

        let selectedVariantIndex

        if (this.state.productWeight === 20 && this.state.purchaseType === "one-time-purchase") {
          this.freeSheepingBlock.setAttribute("style", "display: none")
          selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == "20lbs")
          this.addFreeShippingText(selectedVariantIndex)
        }

        if (this.state.productWeight > 20 && this.state.purchaseType === "one-time-purchase") {
          selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == `${this.state.productWeight}lbs`)

          this.oneTimePurchaseProductPrice.innerHTML = `
                        ${this.formatter.format(this.state.allVariants[selectedVariantIndex].price / 100)}
                    `
        }

        if (this.state.purchaseType === "subscribe-and-save") {
          selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == this.state.productWeight + "lbs")
          this.oneTimePurchaseProductPrice.textContent = this.formatter.format(this.state.allVariants[selectedVariantIndex].price / 100)
        }

        this.state.selectedVariantId = this.state.allVariants[selectedVariantIndex].id
      })
    })

    const oneTimePurchaseAddToCartButton = document.querySelector(".template-old #one-time-purchase-add-to-cart")
    oneTimePurchaseAddToCartButton.addEventListener("click", () => this.addOneTimePurchaseProductToCart())

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.addEventListener("click", () => this.addSubscriptionProductToCart())
    purchaseTypeCheckboxes[0].click()

    const modalAddtoCart = document.querySelector(".pdp-modal-form__btn")
    const modalInput = document.querySelector(".pdp-modal-form__value")

    modalAddtoCart.addEventListener("click", () => {
      this.state.numberOfCatsSelected = modalInput.value
      this.calculateWeightAndPrice()
      this.addSubscriptionProductToCart2()
      this.state.numberOfCatsSelected = 8
      this.numberOfCatsManualCounterValue.textContent = this.state.numberOfCatsSelected
      this.overlay.style.display = "none"
    })

    this.closeButton.addEventListener(
      "click",
      function () {
        this.hideOverlay()
      }.bind(this)
    )
  }

  hideOverlay() {
    this.state.numberOfCatsSelected = 8
    this.numberOfCatsManualCounterValue.textContent = this.state.numberOfCatsSelected
    this.overlay.style.display = "none"
  }
  async addOneTimePurchaseProductToCart() {
    const formData = {
      items: [
        {
          id: this.state.selectedVariantId,
          quantity: 1,
          properties: {
            _subscribe: "not_subscribed",
          },
        },
      ],
    }

    const cartItems = await this.getItems()
    const itemIndex = cartItems.items.findIndex((item) => item.id == this.state.selectedVariantId)

    if (itemIndex < 0) {
      this.addItem(formData).then((res) => {
        this.toggleCart()
      })
    } else {
      this.toggleCart()
    }
  }
  async addSubscriptionProductToCart() {
    let canAdd = true

    // this.overlayLoading()

    const cartItems = await this.getItems()

    const filteredVariants = cartItems.items.filter((item) => item.id == this.state.selectedVariantId)

    filteredVariants.forEach((item) => {
      if (item.properties._interval == this.state.rechargeInterval) {
        canAdd = false
      }
    })

    if (!canAdd) {
      this.toggleCart()
      return
    }

    let sellingPlanId = ""

    this.state.sellingPlans2.forEach((sellingPlan) => {
      if (this.state.rechargeInterval == 45) {
        sellingPlanId = 2325053589
      } else if (sellingPlan.name.includes(this.state.rechargeInterval)) {
        sellingPlanId = sellingPlan.selling_plans[0].id
      }

      // if (sellingPlan.name.includes(this.state.rechargeInterval)) {

      //   sellingPlanId = sellingPlan.selling_plans[0].id
      // }
    })
    const formData = {
      id: this.state.selectedVariantId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        _interval: this.state.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (this.state.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(this.state.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        this.state.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        this.toggleCart()
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"
  }
  async addSubscriptionBag() {
    let canAdd = true

    // this.overlayLoading()

    const cartItems = await this.getItems()

    var hasCatLitter = cartItems.items.some((item) => item.product_type === "Cat Litter" && Boolean(item.properties?._interval))

    if (!hasCatLitter) {
      document.getElementById("overlay2").style.display = "block"
      return
    }

    const filteredVariants = cartItems.items.filter((item) => item.id == this.state.selectedVariantId)
    filteredVariants.forEach((item) => {
      if (item.properties._interval == this.state.rechargeInterval) {
        canAdd = false
      }
    })

    if (!canAdd) {
      this.toggleCart()
      return
    }

    let sellingPlanId = ""
    this.state.sellingPlans.forEach((sellingPlan) => {
      sellingPlanId = sellingPlan.id
    })
    const formData = {
      id: this.state.selectedVariantId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        _interval: this.state.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (this.state.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(this.state.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        this.state.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        this.toggleCart()
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"
  }
  async addSubscriptionBag4() {
    let canAdd = true

    // this.overlayLoading()

    const cartItems = await this.getItems()

    var hasCatLitter = cartItems.items.some((item) => item.product_type === "Cat Litter" && Boolean(item.properties?._interval))

    if (!hasCatLitter) {
      document.getElementById("overlay2").style.display = "block"
      return
    }

    const filteredVariants = cartItems.items.filter((item) => item.id == this.state.selectedVariantId)
    filteredVariants.forEach((item) => {
      if (item.properties._interval == this.state.rechargeInterval) {
        canAdd = false
      }
    })

    if (!canAdd) {
      this.toggleCart()
      return
    }

    let sellingPlanId = ""
    this.state.sellingPlans.forEach((sellingPlan) => {
      sellingPlanId = sellingPlan.id
    })
    const formData = {
      id: 45065132540053, //id 120 bag
      quantity: 1,
      selling_plan: 2308898965, //id selling plan for 4 month
      properties: {
        _interval: this.state.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (this.state.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(this.state.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        this.state.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        this.toggleCart()
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"
  }
  async addBag() {
    const cartItems = await this.getItems()

    var hasCatLitter = cartItems.items.some((item) => item.product_type === "Cat Litter")
    var additional = cartItems.items.some((item) => item.product_type === "Additional")
    if (!hasCatLitter && !additional) {
      document.getElementById("overlay").style.display = "block"
      return
    }
    const formData = {
      items: [
        {
          id: this.state.selectedVariantId,
          quantity: 1,
          properties: {
            _subscribe: "not_subscribed",
          },
        },
      ],
    }

    const itemIndex = cartItems.items.findIndex((item) => item.id == this.state.selectedVariantId)
    this.addItem(formData).then((res) => {
      this.toggleCart()
    })
  }
  async addSubscriptionProductToCart2() {
    let canAdd = true

    // this.overlayLoading()

    const cartItems = await this.getItems()

    let sellingPlanId = ""
    this.state.sellingPlans.forEach((sellingPlan) => {
      if (sellingPlan.name.includes(this.state.rechargeInterval)) {
        sellingPlanId = sellingPlan.id
      }
    })

    const formData = {
      id: this.state.selectedVariantId,
      quantity: this.state.count,
      selling_plan: sellingPlanId,
      properties: {
        _interval: this.state.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (this.state.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(this.state.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        this.state.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {})
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"

    let selectedVariantIndex
    this.state.productWeight = this.state.remainder
    selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == this.state.productWeight + "lbs")
    const oneTimePurchaseIndex = this.state.allVariants.findIndex((variant) => variant.title == `${this.state.productWeight}lbs`)

    this.oneTimePurchaseProductPrice.textContent = this.formatter.format(this.state.allVariants[oneTimePurchaseIndex].price / 100)

    this.state.selectedVariantId = this.state.allVariants[selectedVariantIndex].id
    await this.addSubscriptionProductToCart()
  }

  calculateWeightAndPrice() {
    const weightDecrementor = this.oneTimePurchaseProductWeightCounters[0]

    if (this.state.numberOfCatsSelected == 1) {
      this.oneTimePurchaseProductWeightValue.textContent = this.state.numberOfCatsSelected * 10 * 2 + "lbs"
      this.state.productWeight = this.state.numberOfCatsSelected * 10 * 2
    } else if (this.state.numberOfCatsSelected == 3) {
      this.oneTimePurchaseProductWeightValue.textContent = "40lbs"
      this.state.productWeight = (this.state.numberOfCatsSelected + 1) * 10
    } else if (this.state.numberOfCatsSelected == 5) {
      this.oneTimePurchaseProductWeightValue.textContent = "60lbs"
      this.state.productWeight = (this.state.numberOfCatsSelected + 1) * 10
    } else if (this.state.numberOfCatsSelected == 7) {
      this.oneTimePurchaseProductWeightValue.textContent = "80lbs"
      this.state.productWeight = (this.state.numberOfCatsSelected + 1) * 10
    } else {
      this.oneTimePurchaseProductWeightValue.textContent = this.state.numberOfCatsSelected * 10 + "lbs"
      this.state.productWeight = this.state.numberOfCatsSelected * 10
    }

    if (this.state.productWeight > 20) {
      weightDecrementor.removeAttribute("disabled")
    }

    if (this.state.productWeight == 20) {
      weightDecrementor.setAttribute("disabled", true)
    }

    let selectedVariantIndex

    if (this.state.numberOfCatsSelected === 1 && this.state.purchaseType === "one-time-purchase") {
      selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == "20lbs")
      this.freeSheepingBlock.setAttribute("style", "display: none")
      this.addFreeShippingText(selectedVariantIndex)
      this.showSavingsValue(`cat_${this.state.numberOfCatsSelected}`, this.state.productWeight)
      this.showSavingsValueInfo(`cat_${this.state.numberOfCatsSelected}`, this.state.productWeight)
      this.showSavingsValueInfoOne(`cat_${this.state.numberOfCatsSelected}`, this.state.productWeight)
    }

    if (this.state.numberOfCatsSelected > 1 && this.state.purchaseType === "one-time-purchase") {
      selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == `${this.state.productWeight}lbs`)

      this.oneTimePurchaseProductPrice.innerHTML = `
                ${this.formatter.format(this.state.allVariants[selectedVariantIndex].price / 100)}
            `
      this.showSavingsValue(`cat_${this.state.numberOfCatsSelected}`, this.state.productWeight)
      this.showSavingsValueInfoOne(`cat_${this.state.numberOfCatsSelected}`, this.state.productWeight)
    }

    if (this.state.purchaseType === "subscribe-and-save") {
      if (this.state.productWeight == 30) {
        this.state.productWeight = 40
      } else if (this.state.productWeight == 50) {
        this.state.productWeight = 60
      } else if (this.state.productWeight == 70) {
        this.state.productWeight = 80
      }

      if (this.state.productWeight > 80) {
        this.state.count = Math.floor(this.state.productWeight / 80)
        this.state.remainder = this.state.productWeight % 80
        this.state.productWeight = 80
        selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == this.state.productWeight + "lbs")
        const oneTimePurchaseIndex = this.state.allVariants.findIndex((variant) => variant.title == `${this.state.productWeight}lbs`)

        this.oneTimePurchaseProductPrice.textContent = this.formatter.format(this.state.allVariants[oneTimePurchaseIndex].price / 100)

        this.state.selectedVariantId = this.state.allVariants[selectedVariantIndex].id
        return
      } else {
        selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == this.state.productWeight + "lbs")
        const oneTimePurchaseIndex = this.state.allVariants.findIndex((variant) => variant.title == `${this.state.productWeight}lbs`)

        this.oneTimePurchaseProductPrice.textContent = this.formatter.format(this.state.allVariants[oneTimePurchaseIndex].price / 100)
      }
    }

    this.state.selectedVariantId = this.state.allVariants[selectedVariantIndex].id
  }

  changeSubAndSaveOption(interval, weight, cat) {
    this.state.rechargeInterval = interval
    this.state.productWeight = weight
    const selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == this.state.productWeight + "lbs")

    this.state.selectedVariantId = this.state.allVariants[selectedVariantIndex].id

    this.showSavingsValue(cat, weight)
    this.showSavingsValueInfo(cat, weight)
  }

  renderSubAndSaveOptionTemplate(cat, selectByDefault) {
    let html = ``

    for (let index in this.subscriptionOptions[cat]) {
      const option = this.subscriptionOptions[cat][index]
      const reversedIndex = Number(index) - this.subscriptionOptions[cat].length

      let selectedVariantIndex = this.state.allVariants.findIndex((variant) => variant.title == option.weight + "lbs")
      let selectedVariant = this.state.allVariants[selectedVariantIndex]

      let selectedVariantPriceAfterDiscount = (selectedVariant.price - selectedVariant.price * 0.18) / 100
      if (Number(index) + 1 === selectByDefault || reversedIndex === selectByDefault) {
        this.state.rechargeInterval = option.interval
        this.state.productWeight = option.weight
        this.state.selectedVariantId = selectedVariant.id
      }

      html += `
      
              <li class="options__item">
                <input 
                    onchange="productFormOld.changeSubAndSaveOption(${option.interval}, ${option.weight}, '${cat}')" 
                    class="options_selector"  
                    name="sub-options" 
                    id="sub-option-${option.weight}" 
                    type="radio" 
                    hidden
                    ${Number(index) + 1 === selectByDefault ? "checked" : ""}
                    ${reversedIndex === selectByDefault ? "checked" : ""}
                />
                <label class="label--simple full" for="sub-option-${option.weight}">
                    ${
                      option.eco
                        ? `
                        <div class="eco-box eco-updated">
                            <div class="tooltip">
                                <img src="${ecoImg}" alt="" />
                                <div class="text__updated">
                                    Fewer shipments = a lower carbon footprint.
                                </div>
                                <div class="square"></div>
                            </div>
                            <span class="eco-label">Eco</span>
                            <span class="eco-label-updated"> <img src="${ecoUpdateImg}" alt="" /></span>
                        </div>
                    `
                        : ""
                    }
                    <div class="weight">
                        <span class="heading">${option.weight}lbs</span>
                       
                        
                      Every ${option.interval === 1 ? "" : option.interval === 45 ? "1.5" : option.interval} ${option.interval === 45 ? "months" : `Month${option.interval > 1 ? "s" : ""}`}
                    </div>
                    <div class="price">
                        <span class="paragraph">
                        ${option.weight === 40 && option.interval === 45 ? "$32.66/Month" : option.interval === 45 ? "$18.66/Month" : `${this.formatter.format(selectedVariantPriceAfterDiscount / option.interval)}/month`}
                        
                        </span>
                        <span class="heading">
                            ${this.formatter.format(selectedVariantPriceAfterDiscount)}
                        </span>
                    </div>
                </label>
              </li>   
            `
    }

    const subscribeAndSaveOptionsWrapper = document.querySelector(".template-old #subscribe-and-save-options")
    subscribeAndSaveOptionsWrapper.innerHTML = html

    this.showSavingsValue(cat, this.state.productWeight)
    this.showSavingsValueInfo(cat, this.state.productWeight)
  }

  renderSubAndSaveOptions() {
    if (this.state.numberOfCatsSelected == 3) {
      this.renderSubAndSaveOptionTemplate(`cat_${this.state.numberOfCatsSelected}`, 1)
    } else {
      this.renderSubAndSaveOptionTemplate(`cat_${this.state.numberOfCatsSelected}`, -1)
    }
  }

  showSelectedSubscription(weight, interval, line) {
    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Update Cart"

    const cartWrapper = document.querySelector(".template-old .ajax-cart__wrapper")
    cartWrapper.classList.remove("open")
    document.body.removeAttribute("style")

    this.state.selectedBeingEditingVariantLine = line
    this.state.purchaseType = "subscribe-and-save"
    this.state.productWeight = parseInt(weight)

    const purchaseTypeCheckboxes = document.querySelectorAll(".template-old input[name='purchase-type']")
    purchaseTypeCheckboxes[0].checked = true

    this.oneTimePurchaseFormBlock.setAttribute("style", "display: none")

    this.subscribeAndSaveFormBlock.removeAttribute("style")
    for (let cat in this.subscriptionOptions) {
      this.subscriptionOptions[cat].forEach((element, index) => {
        if (element.weight === parseInt(weight) && element.interval === Number(interval)) {
          this.renderSubAndSaveOptionTemplate(cat, Number(index) + 1)

          this.state.numberOfCatsSelected = Number(cat.split("_")[1])

          if (this.state.numberOfCatsSelected <= 3) {
            this.numberOfCatsCheckboxes.forEach((checkbox) => {
              const { value } = checkbox.dataset

              if (Number(value) === this.state.numberOfCatsSelected) {
                checkbox.checked = true
              }
            })
          } else {
            const numberOfCatsManualDecrementor = this.numberOfCatsManualCounters[0]
            const numberOfCatsManualIncrementor = this.numberOfCatsManualCounters[1]

            this.numberOfCatsManualCounterWrapper.classList.add("active")
            this.numberOfCatsCheckboxes.forEach((checkbox) => (checkbox.checked = false))
            this.numberOfCatsManualCounterValue.textContent = this.state.numberOfCatsSelected

            if (this.state.numberOfCatsSelected > 4) {
              numberOfCatsManualDecrementor.removeAttribute("disabled")
            }

            if (this.state.numberOfCatsSelected + 1 === 9) {
              numberOfCatsManualIncrementor.setAttribute("disabled", true)
            }
          }
        }
      })
    }
  }

  showSavingsValue(cat, weight = null) {
    const savingsMapping = {
      cat_1: {
        10: "18%",
        20: "50%",
        40: "57%",
      },
      cat_2: {
        20: "18%",
        40: "29%",
      },
      cat_3: {
        30: "18%",
        60: "23%",
      },
      cat_4: {
        40: "27%",
      },
      cat_5: {
        50: "27%",
      },
      cat_6: {
        60: "27%",
      },
      cat_7: {
        70: "27%",
      },
      cat_8: {
        80: "27%",
      },
    }

    const savingValue = savingsMapping[cat] && savingsMapping[cat][weight]
    const highestSavingValue = savingsMapping[cat] && savingsMapping[cat][Object.keys(savingsMapping[cat])[Object.keys(savingsMapping[cat]).length - 1]]

    if (savingValue) {
      this.setSavingValues("", savingValue, highestSavingValue)
    }
  }
  setSavingValues(dollar, percentage, highestSavingValue) {
    const dollarSavings = document.querySelector(".template-old #dollars_saving")
    dollarSavings.textContent = dollar

    const percantageSavings = document.querySelector(".template-old #percantage_saving")
    percantageSavings.textContent = percentage

    const percentageSavingsOneTime = document.querySelector(".template-old #percantage_saving_onetime")
    percentageSavingsOneTime.textContent = highestSavingValue
  }

  showSavingsValueInfo(cat, weight = null) {
    const savingsMapping = {
      cat_1: {
        10: "1x10lbs pack",
        20: "1x20lbs pack",
        40: "2x20lbs packs",
      },
      cat_2: {
        20: "1x20lbs pack",
        40: "2x20lbs packs",
      },
      cat_3: {
        30: "1x20lbs, 1x10lbs packs",
        60: "3x20lbs packs",
      },
      cat_4: {
        40: "2x20lbs packs",
      },
      cat_5: {
        50: "2x20, 1x10lbs packs",
      },
      cat_6: {
        60: "3x20lbs packs",
      },
      cat_7: {
        70: "3x20, 1x10lbs packs",
      },
      cat_8: {
        80: "4x20lbs packs",
      },
    }

    const savingValue = savingsMapping[cat] && savingsMapping[cat][weight]

    if (savingValue) {
      this.setSavingValuesInfo(weight, savingValue)
    }
  }
  setSavingValuesInfo(weight, value) {
    if (document.querySelector(".template-old .pdp-weight-block__weight-js") && document.querySelector(".template-old .pdp-weight-block__value")) {
      const percantageSavings = document.querySelector(".template-old .pdp-weight-block__weight-js")
      percantageSavings.textContent = weight

      const percentageSavingsOneTime = document.querySelector(".template-old .pdp-weight-block__value")
      percentageSavingsOneTime.textContent = value
    }
  }
  showSavingsValueInfoOne(cat, weight = null) {
    const savingsMapping = {
      cat_1: {
        10: "1x10lbs pack",
        20: "1x20lbs pack",
        40: "2x20lbs packs",
      },
      cat_2: {
        20: "1x20lbs pack",
        40: "2x20lbs packs",
      },
      cat_3: {
        30: "1x20lbs, 1x10lbs packs",
        60: "3x20lbs packs",
      },
      cat_4: {
        40: "2x20lbs packs",
      },
      cat_5: {
        50: "2x20, 1x10lbs packs",
      },
      cat_6: {
        60: "3x20lbs packs",
      },
      cat_7: {
        70: "3x20, 1x10lbs packs",
      },
      cat_8: {
        80: "4x20lbs packs",
      },
    }

    const savingValue = savingsMapping[cat] && savingsMapping[cat][weight]

    if (savingValue) {
      this.setSavingValuesInfoOne(weight, savingValue)
    }
  }

  setSavingValuesInfoOne(weight, value) {
    if (document.querySelector(".template-old .pdp-weight-block__weight-js") && document.querySelector(".template-old .pdp-weight-block__value")) {
      const percantageSavings = document.querySelector(".template-old .pdp-weight-block__weight-js--one")
      percantageSavings.textContent = weight

      const percentageSavingsOneTime = document.querySelector(".template-old .pdp-weight-block__value--one")
      percentageSavingsOneTime.textContent = value
    }
  }

  addFreeShippingText(selectedVariantIndex) {
    const text = `
            <span>${this.formatter.format(this.state.allVariants[selectedVariantIndex].price / 100)}</span>
            
        `
    this.oneTimePurchaseProductPrice.innerHTML = text
  }
}
var subscriptionOptions2 = {
  cat_1: [
    {
      weight: 20,
      pricePerDelivery: 19,
      interval: 3,
      perBagPrice: 19,
    },
  ],
  cat_2: [
    {
      weight: 20,
      pricePerDelivery: 28.5,
      interval: 45,
      perBagPrice: 14.25,
    },
    {
      weight: 40,
      pricePerDelivery: 49.4,
      interval: 3,
    },
  ],
  cat_3: [
    {
      weight: 20,
      pricePerDelivery: 39.3,
      interval: 1,
      perBagPrice: 13.1,
    },
    {
      weight: 40,
      pricePerDelivery: 74.1,
      interval: 2,
      // eco: true,
      perBagPrice: 12.35,
    },
  ],
  cat_4: [
    {
      weight: 40,
      pricePerDelivery: 49.4,
      interval: 45,
      // eco: true,
      perBagPrice: 12.35,
    },
  ],
  cat_5: [
    {
      weight: 40,
      pricePerDelivery: 61.75,
      interval: 1,
      // eco: true,
      perBagPrice: 12.35,
    },
  ],
  cat_6: [
    {
      weight: 40,
      pricePerDelivery: 74.1,
      interval: 1,
      // eco: true,
      perBagPrice: 12.35,
    },
  ],
  cat_7: [
    {
      weight: 60,
      pricePerDelivery: 86.45,
      interval: 1,
      // eco: true,
      perBagPrice: 12.35,
    },
  ],
  cat_8: [
    {
      weight: 60,
      pricePerDelivery: 98.8,
      interval: 1,
      // eco: true,
      perBagPrice: 12.35,
    },
  ],
  cat_9: [
    {
      weight: 60,
      pricePerDelivery: 98.8,
      interval: 1,
      // eco: true,
      perBagPrice: 12.35,
    },
  ],
  cat_10: [
    {
      weight: 80,
      pricePerDelivery: 98.8,
      interval: 1,
      // eco: true,
      perBagPrice: 12.35,
    },
  ],
}

const productFormOld = new ProductFormOld(subscriptionOptions2)
setTimeout(function () {
  productFormOld.init()
}, 1000)

// Function to close the modal
function closeModal(element) {
  element.style.display = "none"
}

// Function to add event listeners
function addModalListeners(overlay, closeBtn) {
  closeBtn.addEventListener("click", function () {
    closeModal(overlay)
  })

  window.addEventListener("click", function (event) {
    if (event.target === overlay) {
      closeModal(overlay)
    }
  })
}

// Select overlay elements
const overlay1 = document.getElementById("overlay")
const overlay2 = document.getElementById("overlay2")

// Select close buttons
const closeBtn1 = document.querySelector(".pdp-modal__close")
const closeBtn2 = document.querySelector(".pdp-modal__close2")

// Add listeners to each modal
addModalListeners(overlay1, closeBtn1)
addModalListeners(overlay2, closeBtn2)
